export const IMAGE_FILE_ACCEPT =
  "image/*,.jpg,.jpeg,.png,.heic,.heif,.webp,.JPG,.JPEG,.PNG,.HEIC,.HEIF,.WEBP";

export const ACCEPTED_IMAGE_FORMATS_MESSAGE =
  "Formatos aceitos: JPEG, PNG, WebP e HEIC/HEIF.";

const acceptedExtensions = [
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".heic",
  ".heif",
  ".gif",
  ".bmp",
  ".tif",
  ".tiff",
];

const acceptedMimeTypes = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
  "image/gif",
  "image/bmp",
  "image/tiff",
]);

export function isAcceptedImageFile(file) {
  const filename = String(file?.name || "").toLowerCase();
  const mimeType = String(file?.type || "").toLowerCase();
  const hasAcceptedExtension = acceptedExtensions.some((extension) =>
    filename.endsWith(extension),
  );

  return hasAcceptedExtension && (!mimeType || acceptedMimeTypes.has(mimeType));
}

export function partitionImageFiles(files) {
  return Array.from(files).reduce(
    (result, file) => {
      result[isAcceptedImageFile(file) ? "accepted" : "rejected"].push(file);
      return result;
    },
    { accepted: [], rejected: [] },
  );
}

export function createImagePreview(file) {
  return URL.createObjectURL(file);
}

export function buildImageOrder(images) {
  return images.map((image) =>
    image.type === "new" ? image.file.name : image.url,
  );
}
